export default __webpack_public_path__ + "static/media/btc.8e27390c.png";